interface IJwtPayload {
  exp: number;
  [claim: string]: unknown;
}

const parseToken = (token: string | null): IJwtPayload | undefined =>
  token ? JSON.parse(atob(token.split('.')[1])) : undefined;

export default parseToken;
